export const token = process.env.REACT_APP_DADATA_APIKEY ?? ''
